// extracted by mini-css-extract-plugin
export default {"ChatContainer":"Chat_ChatContainer__F5pO3"};